const PATH = 'fe.components.measure.view.cycle.meta_data_select_one';

const messages = {
  type: {
    key: `${PATH}.type`,
    defaultValue: '{{category}} Type'
  }
};

export default messages;
